import type { Provider } from "../types";

/** Simple Icons CDN; falls back to local placeholder SVG. */
export function providerIconUrl(provider: Pick<Provider, "id" | "iconSlug" | "name">): string {
  if (provider.iconSlug) {
    return `https://cdn.simpleicons.org/${provider.iconSlug}`;
  }
  return `/icons/fallback.svg`;
}

export function providerInitials(name: string): string {
  const parts = name.replace(/[^a-zA-Z0-9\s]/g, " ").trim().split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return name.slice(0, 2).toUpperCase();
}
